import { FormControl, FormLabel, Grid, TextField, Button } from '@mui/material'
import styles from './styles.module.css'
import { useEffect, useRef, useState } from 'react';

const ConfirmarDados = ({ dataForm,
  files,
  handleStep,
  handleSubmit,
  setHasReachedLastStep,
  cidade,
  title }) => {

  const [buttonEnabled, setButtonEnabled] = useState(false);
  const formRef = useRef(null);

  const handleScroll = () => {
    const div = formRef.current;
    const tolerance = 10;
    // console.log(div.scrollTop + div.clientHeight >= div.scrollHeight - tolerance);
    if (div.scrollTop + div.clientHeight >= div.scrollHeight - tolerance) {
      setButtonEnabled(true);
    }
  };

  useEffect(() => {
    setHasReachedLastStep(true);
    const div = formRef.current;
    div.addEventListener("scroll", handleScroll);

    // Cleanup
    return () => {
      div.removeEventListener("scroll", handleScroll);
    }
  }, []);


  const handleBack = () => {
    handleStep(5)
  }

  return (
    <>
      <div ref={formRef} className={styles.container}>
        <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
          <Grid item xs={12} sm={12} >
            <h4 className={styles.titulosConfirmacao}>
              1 - Dados do {title}
            </h4>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              size="small"
              label="Nome"
              fullWidth
              disabled
              value={dataForm.dadosTitular.nome}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              size="small"
              label="CEP"
              fullWidth
              value={dataForm.dadosTitular.cep}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={5} md={6}>
            <TextField
              size="small"
              label="Logradouro"
              fullWidth
              value={dataForm.dadosTitular.logradouro}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={2} md={3}>
            <TextField
              size="small"
              label="Bairro"
              fullWidth
              value={dataForm.dadosTitular.bairro}
              disabled
            />
          </Grid>

          <Grid item xs={6} sm={2}>
            <TextField
              size="small"
              label="Número"
              fullWidth
              value={dataForm.dadosTitular.numero}
              disabled
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <TextField
              size="small"
              label="Complemento"
              fullWidth
              value={dataForm.dadosTitular.complemento}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={2} md={3}>
            <TextField
              size="small"
              label="Cidade"
              fullWidth
              value={cidade}
              disabled
            />
          </Grid>

          <Grid item xs={6} sm={2} md={1}>
            <TextField
              size="small"
              label="Estado"
              fullWidth
              value={dataForm.dadosTitular.estado}
              disabled
            />
          </Grid>

          <Grid item xs={6} sm={2} md={1}>
            <TextField
              size="small"
              label="Pais"
              fullWidth
              value={dataForm.dadosTitular.pais}
              disabled
            />
          </Grid>


          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="CPF"
              fullWidth
              value={dataForm.dadosTitular.cpf}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="E-mail"
              value={dataForm.dadosTitular.email}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="Telefone"
              fullWidth
              value={dataForm.dadosTitular.telefone}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="WhatsApp"
              fullWidth
              value={dataForm.dadosTitular.whatsapp}
              disabled
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
          <Grid item xs={12} sm={12}>
            <h4 className={styles.titulosConfirmacao}>
              2 - Responsável pela Empresa
            </h4>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              size="small"
              label="Nome"
              value={dataForm.responsavelEmpresa.nome}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              size="small"
              label="Profissão"
              fullWidth
              value={dataForm.responsavelEmpresa.profissao}
              disabled
            />
          </Grid>

          <Grid item xs={5} sm={2}>
            <FormControl>
              <FormLabel
                id="demo-row-radio-buttons-group-label"
                sx={{ fontSize: "0.8rem" }}
              >
                Estrangeiro?
              </FormLabel>
              <h5 style={{ margin: 0, color: "gray" }}>
                {dataForm.responsavelEmpresa.estrangeiro === 'true' ? "Sim" : "Não"}
              </h5>
            </FormControl>
          </Grid>

          <Grid item xs={7} sm={2}>
            <TextField
              size="small"
              fullWidth
              value={dataForm.responsavelEmpresa.tipoDocumento}
              label="Tipo do Documento"
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <TextField
              size="small"
              label="Documento"
              fullWidth
              value={dataForm.responsavelEmpresa.documento}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <TextField
              size="small"
              label="CPF"
              fullWidth
              value={dataForm.responsavelEmpresa.cpf}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <TextField
              size="small"
              label="Ramo de atividade"
              fullWidth
              value={dataForm.responsavelEmpresa.ramo}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              size="small"
              label="E-mail"
              type="email"
              value={dataForm.responsavelEmpresa.email}
              disabled
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              size="small"
              label="NºOAB"
              disabled
              fullWidth
              value={dataForm.responsavelEmpresa.oab}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              size="small"
              label="CRC"
              fullWidth
              value={dataForm.responsavelEmpresa.crc}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <TextField
              size="small"
              label="Telefone"
              fullWidth
              value={dataForm.responsavelEmpresa.telefone}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              size="small"
              label="WhatsApp"
              fullWidth
              value={dataForm.responsavelEmpresa.whatsapp}
              disabled
              required
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormControl>
              <FormLabel
                id="demo-row-radio-buttons-group-label"
                sx={{ fontSize: "0.8rem" }}
              >
                Alguém te Indicou?
              </FormLabel>
              <h5 style={{ margin: 0, color: "gray" }}>
                {dataForm.responsavelEmpresa.foiIndicado === 'true' ? "Sim" : "Não"}
              </h5>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="Indicado Por..."
              fullWidth
              disabled
              value={dataForm.responsavelEmpresa.indicadoPor}
              style={{
                display: dataForm.responsavelEmpresa.foiIndicado === 'true' ? "block" : "none",
              }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
          <Grid item xs={12} sm={12}>
            <h4 className={styles.titulosConfirmacao}>
              3 - Responsável Financeiro
            </h4>
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              size="small"
              label="Nome"
              fullWidth
              value={dataForm.responsavelFinanceiro.nome}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              size="small"
              label="E-mail"
              fullWidth
              value={dataForm.responsavelFinanceiro.email}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              size="small"
              label="Tipo Documento"
              fullWidth
              value={dataForm.responsavelFinanceiro.tipoDocumento}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="Documento"
              fullWidth
              value={dataForm.responsavelFinanceiro.documento}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="CPF"
              fullWidth
              value={dataForm.responsavelFinanceiro.cpf}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="Telefone"
              fullWidth
              value={dataForm.responsavelLegal.telefone}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="WhatsApp"
              fullWidth
              value={dataForm.responsavelLegal.whatsapp}
              disabled
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
          <Grid item xs={12} sm={12}>
            <h4 className={styles.titulosConfirmacao}>
              4 - Responsável Legal
            </h4>
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              size="small"
              label="Nome"
              fullWidth
              value={dataForm.responsavelLegal.nome}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              size="small"
              label="E-mail"
              fullWidth
              value={dataForm.responsavelLegal.email}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              size="small"
              label="Tipo Documento"
              fullWidth
              value={dataForm.responsavelLegal.tipoDocumento}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="Documento"
              fullWidth
              value={dataForm.responsavelLegal.documento}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="CPF"
              fullWidth
              value={dataForm.responsavelLegal.cpf}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="Telefone"
              fullWidth
              value={dataForm.responsavelLegal.telefone}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="WhatsApp"
              fullWidth
              value={dataForm.responsavelLegal.whatsapp}
              disabled
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
          <Grid item xs={12} sm={12}>
            <h4 className={styles.titulosConfirmacao}>
              5 - Dados do Procurador
            </h4>
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              size="small"
              label="Nome"
              fullWidth
              value={dataForm.dadosProcurador.nome}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              size="small"
              label="E-mail"
              fullWidth
              value={dataForm.dadosProcurador.email}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              size="small"
              label="Tipo Documento"
              fullWidth
              value={dataForm.dadosProcurador.tipoDocumento}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="Documento"
              fullWidth
              value={dataForm.dadosProcurador.documento}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="CPF"
              fullWidth
              value={dataForm.dadosProcurador.cpf}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="Telefone"
              fullWidth
              value={dataForm.dadosProcurador.telefone}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="WhatsApp"
              fullWidth
              value={dataForm.dadosProcurador.whatsapp}
              disabled
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
          <Grid item xs={12} sm={12}>
            <h4 className={styles.titulosConfirmacao}>
              6 - Dados Bancários
            </h4>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              size="small"
              fullWidth
              disabled
              value={dataForm.dadosBancarios.banco}
              label="Banco"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              size="small"
              label="Agência"
              fullWidth
              disabled
              value={dataForm.dadosBancarios.agencia}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="Conta"
              fullWidth
              disabled
              value={dataForm.dadosBancarios.conta}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              label="PIX"
              value={dataForm.dadosBancarios.pix}
              fullWidth
              disabled
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
          <Grid item xs={12} sm={12}>
            <h4 className={styles.titulosConfirmacao}>
              7 - Anexo de Documentos
            </h4>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              label="RG"
              value={"rg" in files ? files["rg"].name : ""}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              label="CPF"
              value={"cpf" in files ? files["cpf"].name : ""}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              label="Comp. Residência"
              value={
                "comprovante_residencia" in files
                  ? files["comprovante_residencia"].name
                  : ""
              }
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              label="Passaporte"
              value={
                "passaporte" in files ? files["passaporte"].name : ""
              }
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              label="RNE"
              value={"rne" in files ? files["rne"].name : ""}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              label="CPF dos Sócios"
              value={
                "cpf_socios" in files ? files["cpf_socios"].name : ""
              }
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              label="Comp. Resd. Sócios"
              value={
                "comprovante_residencia_socios" in files
                  ? files["comprovante_residencia_socios"].name
                  : ""
              }
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              label="Comp. Resd. Empresa"
              value={
                "comprovante_residencia_empresa" in files
                  ? files["comprovante_residencia_empresa"].name
                  : ""
              }
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              label="Contrato Social"
              value={
                "contrato_social" in files
                  ? files["contrato_social"].name
                  : ""
              }
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              label="Cartão CNPJ"
              value={
                "cartao_cnpj" in files
                  ? files["cartao_cnpj"].name
                  : ""
              }
              fullWidth
              disabled
            />
          </Grid>
        </Grid>
      </div>
      <div className={styles.container_button}>
        <Button
          className={styles.button_back}
          onClick={handleBack}
        >
          Voltar
        </Button>
        <Button
          className={buttonEnabled ? styles.button_next : styles.button_next_disable}
          onClick={handleSubmit}
          disabled={!buttonEnabled}
        >
          Finalizar
        </Button>
      </div>
    </>
  )
}

export default ConfirmarDados